export default __webpack_public_path__ + "static/class-books-2272e08c1542803e0a2d71382ee69551.png";